import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getWorkshopPage } from '@/pages/baseData/workshopManagement/api'
import { cloneDeep } from '@/utils/tools'

export const fetchGetWorkshopsAsync = createAsyncThunk('workshop/page', () =>
  axios.get(getWorkshopPage(), { params: { noPage: true } }).then((response) => {
    return response?.data.items
  })
)

const workshopSlice = createSlice({
  name: 'workshop',
  initialState: {
    workshopList: [],
    workshopDiabeledList: [],
    workshopDict: {},
  },
  reducers: {
    setWorkshopList(state, action) {
      state.workshopList = action.payload
    },
    setWorkshopDict(state, action) {
      state.workshopDict = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetWorkshopsAsync.pending, (state) => {
        state.workshopList = []
        state.workshopDiabeledList = []
        state.workshopDict = {}
      })
      .addCase(fetchGetWorkshopsAsync.fulfilled, (state, action) => {
        state.workshopList = action.payload
        state.workshopDiabeledList = cloneDeep(action.payload)
        if (state.workshopList) {
          state.workshopList.forEach((item) => {
            state.workshopDict[item.id] = item
          })
          state.workshopDiabeledList.map((item) => {
            item.disabled = item.status == '0' ? true : false
          })
        }
      })
  },
})

export const { setWorkshopList, setWorkshopDict } = workshopSlice.actions
export const getWorkshopList = (state) => state.workshop.workshopList
export const getWorkshopDisabledList = (state) =>
  state.workshop.workshopDiabeledList
export const getWorkshopDict = (state) => state.workshop.workshopDict
export default workshopSlice.reducer
